// --- Show/Hide Mobile Logo re: Search UI ---

function hideLogo() {
  document.querySelector(".site-header__logo").style.display = "none";
}
function showLogo() {
  document.querySelector(".site-header__logo").style.display = "block";
}